import React from "react";
import ReactDOM from "react-dom/client";
import "./configureAmplify";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { initializeObservability } from "./utils/observability";

initializeObservability();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
